const Regions = {
  Africa: 'Africa',
  Asia: 'Asia',
  'Middle East': 'Middle East',
  Caribbean: 'Caribbean',
  'Central America': 'Central America',
  Europe: 'Europe',
  'North America': 'North America',
  Oceania: 'Oceania',
  'South America': 'South America',
  // These are old, typoed values that are kept here temporarily.
  // There is a backend ticket [sc-6759] to fix these in the database.
  // We need to support the typoed values so that the UI doesn't break
  // for existing network profiles.
  NorthAmerica: 'North America',
  MiddleEash: 'Middle East',
  CentralAmerica: 'Central America',
  SoutchAmerica: 'South America'
}

export default Regions
